export default __webpack_public_path__ + "static/media/dot.52abd9cf.png";